<template>
  <div class="print__tabs__overlay">
    <loader />
  </div>
</template>

<script>
export default {
  name: "download-fixtures-loader",
};
</script>
